import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from '@apollo/client';
import {PAYD_GRAPHQL_URL} from "./env";
import {setContext} from '@apollo/client/link/context';
import {loadErrorMessages, loadDevMessages} from "@apollo/client/dev";
import {onError} from "@apollo/client/link/error";
import {toast} from "react-toastify";
import {handleXErrorMessage} from "./errors";
import useAuthStore from "../store/auth";

const httpLink = new HttpLink({
    uri: PAYD_GRAPHQL_URL,
    credentials: 'include'
});

const authLink = setContext((_, {headers}) => {
    // Get token from Zustand store. Don't send 'session_active' as it's a placeholder
    // for httpOnly cookie authentication and would override the actual cookie.
    const token = useAuthStore.getState()?.token;
    if (token && token !== 'session_active') {
        return {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`
            }
        };
    }
    return {headers: {...headers}};
});

const errorLink = onError(({graphQLErrors, networkError}) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(({message, locations, path, extensions}) => {
            if (message && message?.startsWith('X_ERROR/')) {
                handleXErrorMessage(message.replace('X_ERROR/', ''));
                return;
            }
            if (message && message?.startsWith('Z_ERROR/')) {
                toast.error(message.replace('Z_ERROR/', ''));
                return;
            }
            if (message === 'Unauthenticated.' || message === 'Unauthenticated') {
                console.log(`Unauthenticated`);
                useAuthStore.getState().clearToken();
                window.location.href = process.env.REACT_APP_PAYD_URL + `/login`;
                return;
            }

            // Extract Lighthouse / Laravel GraphQL validation errors from extensions.validation
            if (extensions?.validation && typeof extensions.validation === 'object') {
                const validationMessages = Object.values(extensions.validation).flat();
                if (validationMessages.length > 0) {
                    validationMessages.forEach((msg) => {
                        if (msg) toast.error(msg);
                    });
                    return;
                }
            }

            console.log(`GraphQL error: ${message}`);
            if (message) {
                toast.error(message);
            }
        });
    }
    if (networkError) {
        console.log(`Network error: ${networkError}.`);
        toast.error(networkError.message || 'Network error occurred.');
    }
});

export const apollo = new ApolloClient({
    cache: new InMemoryCache(),
    link: ApolloLink.from([authLink, errorLink, httpLink]),
    defaultOptions: {
        query: {
            fetchPolicy: 'network-only',
        },
        watchQuery: {
            fetchPolicy: 'network-only',
        },
    },
});


if (process.env.NODE_ENV !== "production") {
    loadDevMessages();
    loadErrorMessages();
}